import { Navigate } from "react-router-dom";

// Legacy /terms → canonical /legal/terms. The full ToS lives at
// /app/frontend/src/pages/legal/TermsOfService.jsx.
export default function Terms() {
  return <Navigate to="/legal/terms" replace />;
}
